<template>
    <div>
        <div class="preview-opration">
            <el-select :value="query.language" @change="handleQueryChange('language', $event)" placeholder="请选择">
                <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="createDialog">新增
            </el-button>
        </div>
        <div class="recommend-item-list">
            <el-table class="recommend-item-table" border
                      :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="recommendItemList" :row-key="() => Math.random()">
                <el-table-column prop="itemOder" label="序号" width="100px" show-overflow-tooltip></el-table-column>
                <el-table-column label="图标" width="100px">
                    <template slot-scope="scope">
                        <img style="width: 50px; height: 50px" :src="scope.row.itemIconUrl"/>
                    </template>
                </el-table-column>
                <el-table-column prop="itemTitle" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column label="类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.itemType | formatType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="排序方式" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.sortOrder | formatSort}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="showNum" label="显示数量" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.activated | formatState}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300px">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="updateDialog(scope.row)">修改
                        </el-button>
                        <el-button v-if="scope.row.activated==0" type="danger" icon="el-icon-delete"
                                   @click="handleRemove(scope.row.id,'NO')">下架
                        </el-button>
                        <el-button v-if="scope.row.activated==1" type="danger" icon="el-icon-delete"
                                   @click="handleRemove(scope.row.id,'YES')">上架
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div>
                    <span style="padding-right: 48px"><span style="color: red">*</span> 序号</span>
                    <el-input-number v-model="itemData.itemOder" :min="0" :max="10000000"
                                     style="width: 200px"></el-input-number>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 显示数量</span>
                    <el-input-number v-model="itemData.showNum" :min="0" :max="10000000"
                                     style="width: 200px"></el-input-number>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 48px"><span style="color: red">*</span> 名称</span>
                    <el-input maxlength="20" v-model="itemData.itemTitle" style="width: 70%"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 48px"><span style="color: red">*</span> 类型</span>
                    <el-select v-model="itemData.itemType" placeholder="请选择...">
                        <el-option v-for="item in itemTypeOption" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 排序方式</span>
                    <el-select v-model="itemData.sortOrder" placeholder="请选择...">
                        <el-option v-for="item in sortTypeOption" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 33px"><span style="color: red">*</span> 图标</span>
                    <uploadMoulde :value="itemData.itemIconUrl" style="margin-left: 15px;display: inline-block" :limitNumber="1"
                                  v-on:input="getSucessInfo" ref="childUpload"></uploadMoulde>
                </div>
                <div style="margin-top: 20px" v-if="itemData.itemType=='PICTURE'">
                    <span style="padding-right: 20px"><span style="color: red">*</span> 广告链接</span>
                    <el-input v-model="itemData.adUrl" style="width: 70%"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 21px"><span style="color: white">*</span> 选择时间</span>
                    <el-date-picker v-model="dateArr" value-format="timestamp" type="datetimerange" range-separator="——"
                                    start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="createRecommendItem">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState} from 'vuex';
    import uploadMoulde from "../../../components/upload/indexLimit.vue";

    export default {
        name: 'RecommendItem',
        components: {
            uploadMoulde
        },
        data() {
            return {
                recommendItemList: [], //推荐位列表
                total: 0, //总条数
                queryParams: { //查询参数
                    lang: "",
                    page: 1,
                    size: 10
                },
                itemData: { //数据
                    id: -1,
                    itemTitle: "",
                    itemIconUrl: "",
                    adUrl: "",
                    itemType: "",
                    showNum: 3,
                    sortOrder: "",
                    itemOder: 0,
                    param: "",
                    lang: ""
                },
                dialogVisible: false, //对话框是否显示
                dialogTitle: "",  //弹框标题
                currOpration: 0,  //当前操作 0-新增，1修改
                dateArr: [], //日期
                itemTypeOption: [{
                    label: '最新类容',
                    value: 'LATEST_CONTENTS'
                }, {
                    label: '大家都在看',
                    value: 'EVERYBODY_WATCHING'
                }, {
                    label: '推荐文章',
                    value: 'RECOMMEND_ARTICLE'
                }, {
                    label: '热文',
                    value: 'THERMOGRAPHY'
                }, {
                    label: '图片推荐项',
                    value: 'PICTURE'
                }],
                sortTypeOption: [{
                    label: '时间降序',
                    value: 'TIME_DESC'
                }, {
                    label: '点击量',
                    value: 'HITS'
                }, {
                    label: '随机',
                    value: 'RANDOM'
                }]
            };
        },
        computed: {
            ...mapState('cmsManage', ['languageList', 'query'])
        },
        filters: {
            formatState(state) {
                switch (state) {
                    case 0:
                        return "上架";
                    case 1:
                        return "下架";
                }
            },
            formatType(type) {
                switch (type) {
                    case 'LATEST_CONTENTS':
                        return "最新类容";
                    case 'EVERYBODY_WATCHING':
                        return "大家都在看";
                    case 'RECOMMEND_ARTICLE':
                        return "推荐文章";
                    case 'THERMOGRAPHY':
                        return "热文";
                    case 'PICTURE':
                        return "图片推荐项";
                }
            },
            formatSort(sort) {
                switch (sort) {
                    case 'TIME_DESC':
                        return "时间降序";
                    case 'HITS':
                        return "点击量";
                    case 'RANDOM':
                        return "随机";
                }
            }
        },
        methods: {
            ...mapMutations('cmsManage', ['changeQuery']),
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.queryParams.page = 1;
                this.queryParams.lang = value;
                this.getRecommendItemList(this.queryParams);
            },
            getRecommendItemList(query) {
                api.getRecommendItemList(query).then(({data}) => {
                    this.recommendItemList = data.records;
                    this.total = data.total;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getRecommendItemList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getRecommendItemList(this.queryParams);
            },
            getSucessInfo(data) {
                //上传成功
                this.itemData.itemIconUrl = data;
            },
            createDialog() {
                this.currOpration = 0;
                this.dialogTitle = "新增推荐项";
                this.dialogVisible = true;
            },
            updateDialog(row) {
                this.currOpration = 1;
                this.dialogTitle = "修改推荐项";
                this.itemData.id = row.id;
                this.itemData.itemTitle = row.itemTitle;
                this.itemData.itemIconUrl = row.itemIconUrl;
                this.itemData.showNum = row.showNum;
                this.itemData.itemType = row.itemType;
                this.itemData.sortOrder = row.sortOrder;
                this.itemData.itemOder = row.itemOder;
                this.itemData.param = row.param;
                this.itemData.lang = row.language;
                if(row.param!=""){
                    let params = JSON.parse(row.param);
                    this.dateArr = [params.startTime, params.endTime];
                    this.itemData.adUrl = params.adUrl;
                }
                this.dialogVisible = true;
            },
            createRecommendItem() {
                if (this.itemData.itemOder == "") {
                    this.$message.success('序号不能为空！');
                    return;
                }
                if (this.itemData.itemTitle == "") {
                    this.$message.success('名称不能为空！');
                    return;
                }
                if (this.itemData.showNum == "") {
                    this.$message.success('显示数量不能为空！');
                    return;
                }
                if (this.itemData.itemType == "") {
                    this.$message.success('请选择类型！');
                    return;
                }
                if (this.itemData.itemType == "PICTURE" && this.itemData.adUrl == "") {
                    this.$message.success('请输入广告链接！');
                    return;
                }
                if (this.itemData.sortOrder == "") {
                    this.$message.success('请上选择排序方式！');
                    return;
                }
                if (this.itemData.itemIconUrl == "") {
                    this.$message.success('请选上传图标！');
                    return;
                }
                if(this.dateArr==null || this.dateArr==""){
                    this.dateArr = [];
                }
                let param = {startTime: this.dateArr[0], endTime: this.dateArr[1], sortOrder: this.itemData.sortOrder, adUrl:this.itemData.adUrl};
                this.itemData.param = JSON.stringify(param);
                this.itemData.lang = this.query.language;
                if (this.currOpration == 1) {
                    api.updateRecommendItem(this.itemData).then(({data}) => {
                        this.dialogVisible = false;
                        this.queryParams.lang = this.query.language;
                        this.getRecommendItemList(this.queryParams);
                    });
                } else {
                    api.addRecommendItem(this.itemData).then(({data}) => {
                        this.dialogVisible = false;
                        this.queryParams.lang = this.query.language;
                        this.getRecommendItemList(this.queryParams);
                    });
                }
            },
            handleRemove(id, status) {
                this.$confirm('确认此操作吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.recommendItemActivated({"id": id, "activated": status}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.queryParams.lang = this.query.language;
                        this.getRecommendItemList(this.queryParams);
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.$refs.childUpload.handleRemove();
                this.itemData = { //数据
                    id: -1,
                    itemTitle: "",
                    itemIconUrl: "",
                    itemType: "",
                    showNum: 3,
                    sortOrder: "",
                    itemOder: 0,
                    param: "",
                    lang: ""
                }
                this.dateArr = null;
            }
        },
        created() {
            this.queryParams.lang = this.query.language;
            this.getRecommendItemList(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
        float: right;
    }

    .recommend-item-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .recommend-item-table {
            margin-top: 30px;
        }
    }
</style>